<template>
  <div class="p-m-2">
    <Card>
      <template #title="">
        ยินดีต้อนรับ
      </template>
      <template #content="">
        <div class="p-grid">
          <div class="p-col-12">
            คุณได้ทำการเชื่อมต่อกับระบบ Line Notification เรียบร้อยแล้ว
          </div>
          <div class="p-col-12">
            Scan ที่นี้เพื่อเพิ่มเพื่อน หรือกด <a :href="lineUrl">ที่นี่</a>
          </div>
          <div class="p-col-12">
            <img :src="qrcode" style="width: 10rem; height: 10rem" />
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useQRCode } from "@vueuse/integrations";

export default defineComponent({
  name: "Home",
  setup() {
    const lineUrl = computed(() => {
      return window.origin.includes("api.haadthip.com")
        ? "https://line.me/R/ti/p/%40839clgex"
        : window.origin.includes("apiqas.haad")
        ? "https://line.me/R/ti/p/%40772eanfg"
        : "https://line.me/R/ti/p/%40839clgex";
    });
    const qrcode = useQRCode(lineUrl.value);
    return { qrcode, lineUrl };
  },
});
</script>
